import { render, staticRenderFns } from "./CMvContentGallery.vue?vue&type=template&id=5d97d076&"
import script from "./CMvContentGallery.vue?vue&type=script&lang=ts&"
export * from "./CMvContentGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports